import { JSX } from 'preact'
import { useMemo, useState } from 'preact/hooks'
import classnames from 'classnames'
import { TBlockProps, Icon, BlockType } from '@gsc/types'
import { useFormContext } from '../Form/useFormContext'
import { useComponentStyle } from '../Style'
import { Icon as IconCmp } from './Icon'

const STAR_ICON: Icon = {
  type: BlockType.Icon,
  src: `
<svg viewBox="0 0 32 32">
  <polygon points="16 23.369 6.333 30.5 10.2 19.09 1.5 12.434 12.133 12.434 16 1.5 19.867 12.434 30.5 12.434 21.8 19.09 25.667 30.5" />
</svg>
`,
}

export function Rating({
  name,
  required,
  icon = STAR_ICON,
  max = 5,
  highlightSelectedOnly = false,
  ...props
}: TBlockProps<BlockType.Rating>): JSX.Element {
  const rates = useMemo<Array<[string, Icon]>>(() => {
    const arr = Array.isArray(icon) ? icon : new Array(max).fill(icon)
    return arr.map((i, idx) => [String(idx + 1), i])
  }, [icon])

  const { classes } = useComponentStyle('input-rating', props)

  const { getValue, setValue } = useFormContext()
  const [hoverValue, setHoverValue] = useState('')

  const value = getValue(name)

  const handleChange = (e: Event) =>
    setValue(name, {
      value: [(e.target as HTMLInputElement).value],
      valid: true,
    })

  return (
    <div className={classnames(classes)}>
      {rates.map(([val, ico]) => {
        const filled = highlightSelectedOnly
          ? val === value || val === hoverValue
          : +val <= Math.max(+value, +hoverValue)

        return (
          <label
            key={val}
            className={classnames({ filled })}
            onMouseEnter={() => setHoverValue(val)}
            onMouseLeave={() => setHoverValue(value)}
          >
            <input
              required={required}
              type="radio"
              name={name}
              value={val}
              onChange={handleChange}
              checked={value === val}
            />
            <IconCmp {...ico} />
          </label>
        )
      })}
    </div>
  )
}
